"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileStatus = exports.CompanyFileDocumentLabel = exports.CompanyFileDocumentType = void 0;
var CompanyFileDocumentType;
(function (CompanyFileDocumentType) {
    CompanyFileDocumentType["Other"] = "other";
    CompanyFileDocumentType["TermSheet"] = "term_sheet";
    CompanyFileDocumentType["Loan"] = "loan";
    CompanyFileDocumentType["IncomeStatement"] = "income_statement";
    CompanyFileDocumentType["BalanceSheet"] = "balance_sheet";
    CompanyFileDocumentType["CustomerTape"] = "customer_tape";
    CompanyFileDocumentType["CashFlowStatement"] = "cash_flow_statement";
    CompanyFileDocumentType["LogoCompany"] = "logo_company";
    CompanyFileDocumentType["CapTable"] = "cap_table";
    CompanyFileDocumentType["FinancialStatementMapping"] = "financial_statement_mapping";
    CompanyFileDocumentType["CapitalMachineModelOutput"] = "capital_machine_model_output";
    CompanyFileDocumentType["DocusignMnda"] = "docusign_mnda";
    CompanyFileDocumentType["CompanyMnda"] = "company_mnda";
    CompanyFileDocumentType["CleanedIncomeStatement"] = "cleaned_income_statement";
    CompanyFileDocumentType["CleanedBalanceSheet"] = "cleaned_balance_sheet";
    CompanyFileDocumentType["CleanedCustomerTransactions"] = "cleaned_customer_tape";
    CompanyFileDocumentType["FinancialSummary"] = "financial_summary";
    CompanyFileDocumentType["PorfolioMonitoringImportSource"] = "porfolio_monitoring_import_source";
    CompanyFileDocumentType["OutOfFeeProof"] = "out_of_fee_proof";
    CompanyFileDocumentType["SyndicationLegalAgreement"] = "syndication_legal_agreement";
    CompanyFileDocumentType["BusinessOverviewDeck"] = "business_overview_deck";
    CompanyFileDocumentType["FeeAgreement"] = "fee_tos_agreement";
    CompanyFileDocumentType["ChartbookInvestorAnalytics"] = "chartbook_investor_analytics";
})(CompanyFileDocumentType = exports.CompanyFileDocumentType || (exports.CompanyFileDocumentType = {}));
var CompanyFileDocumentLabel;
(function (CompanyFileDocumentLabel) {
    CompanyFileDocumentLabel["other"] = "Other";
    CompanyFileDocumentLabel["term_sheet"] = "TermSheet";
    CompanyFileDocumentLabel["loan"] = "Loan";
    CompanyFileDocumentLabel["income_statement"] = "IncomeStatement";
    CompanyFileDocumentLabel["balance_sheet"] = "BalanceSheet";
    CompanyFileDocumentLabel["customer_tape"] = "CustomerTape";
    CompanyFileDocumentLabel["cash_flow_statement"] = "CashFlowStatement";
    CompanyFileDocumentLabel["logo_company"] = "LogoCompany";
    CompanyFileDocumentLabel["cap_table"] = "CapTable";
    CompanyFileDocumentLabel["financial_statement_mapping"] = "FinancialStatementMapping";
    CompanyFileDocumentLabel["capital_machine_model_output"] = "CapitalMachineModelOutput";
    CompanyFileDocumentLabel["docusign_mnda"] = "DocusignMNDA";
    CompanyFileDocumentLabel["company_mnda"] = "CompanyMNDA";
    CompanyFileDocumentLabel["cleaned_income_statement"] = "CleanedIncomeStatement";
    CompanyFileDocumentLabel["cleaned_balance_sheet"] = "CleanedBalanceSheet";
    CompanyFileDocumentLabel["cleaned_customer_tape"] = "CleanedCustomerTape";
    CompanyFileDocumentLabel["financial_summary"] = "FinancialSummary";
    CompanyFileDocumentLabel["porfolio_monitoring_import_source"] = "PorfolioMonitoringImportSource";
    CompanyFileDocumentLabel["out_of_fee_proof"] = "OutOfFeeProof";
    CompanyFileDocumentLabel["syndication_legal_agreement"] = "SyndicationLegalAgreement";
    CompanyFileDocumentLabel["business_overview_deck"] = "BusinessOverviewDeck";
    CompanyFileDocumentLabel["fee_tos_agreement"] = "FeeTOSAgreement";
    CompanyFileDocumentLabel["chartbook_investor_analytics"] = "ChartbookInvestorAnalytics";
})(CompanyFileDocumentLabel = exports.CompanyFileDocumentLabel || (exports.CompanyFileDocumentLabel = {}));
var FileStatus;
(function (FileStatus) {
    FileStatus["AwaitingUpload"] = "awaiting_upload";
    FileStatus["Success"] = "success";
    FileStatus["Failed"] = "failed";
    FileStatus["Pending"] = "pending";
    FileStatus["Processing"] = "processing";
})(FileStatus = exports.FileStatus || (exports.FileStatus = {}));
//# sourceMappingURL=file.js.map